export const defaultTeamQuery = {
  take: 10
}


// WEBPACK FOOTER //
// ./src/constants/teams.js